import { sendGAEvent } from '@noths/polaris-client-google-analytics';

export const trackProductFeaturesImpression = (productFeaturesLabels: string) => {
  sendGAEvent({
    event: 'custom_event',
    event_action: 'Impression',
    event_category: 'PDP Product Features',
    event_label: productFeaturesLabels,
    event_name: 'view_content',
    content_type: 'product features',
    product_features: productFeaturesLabels,
  });
};
